import Visit from '../visit';
import { del, delAllSelected } from './delete';
import { findDelTargetsAllSelect } from './toolkit';

// 解决循环引用，往公共对象上挂
function mountApi() {
    Visit.Remove = {
        del,
        delAllSelected,
        findDelTargetsAllSelect
    };
}

export default {
    mountApi,
    del,
    delAllSelected,
    findDelTargetsAllSelect
};
